module.exports = __webpack_public_path__ + "static/img/banner-bienvenidos-768x1024.776e1b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-bienvenidos-768x1024.jpg
// module id = ghNH
// module chunks = 47